import { type ButtonHTMLAttributes } from "react";
import { XIcon } from "@phosphor-icons/react";

type Props = Pick<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "onClick" | "aria-label"
>;

export function ResetButton({ "aria-label": ariaLabel, onClick }: Props) {
  return (
    <button
      type="button"
      className="shrink-0 cursor-pointer text-text-placeholder"
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <XIcon size={20} aria-hidden />
    </button>
  );
}
